// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_-emX2","foot_link":"index_foot_link_UGOgt","list":"index_list_Z8MHP","link":"index_link_D47Hh","copyright":"index_copyright_snd6X"};